import { t } from "@/lib/i18n";
export const PLANS = [
  {
    key: "basic", name: t("Basic"), price: "19,90", tag: t("Per iniziare"),
    color: "#2563EB", ring: "ring-blue-500/40", text: "text-blue-500", btn: "bg-blue-600 hover:bg-blue-700",
    features: [t("2 agenti"), t("50 prodotti"), t("Clienti con listini dedicati"), t("Ordini, PDF e scorte"), t("Statistiche e report provvigioni")],
  },
  {
    key: "pro", name: t("Pro"), price: "29,90", tag: t("Per reti in crescita"),
    color: "#7C3AED", ring: "ring-violet-500/40", text: "text-violet-500", btn: "bg-violet-600 hover:bg-violet-700",
    features: [t("5 agenti"), t("200 prodotti"), t("Clienti con listini dedicati"), t("Ordini, PDF e scorte"), t("Statistiche e report provvigioni"), t("Assistente AI con chat integrata")],
  },
  {
    key: "premium", name: t("Premium"), price: "49,90", tag: t("Tutto illimitato"),
    color: "#10B981", ring: "ring-emerald-500/40", text: "text-emerald-500", btn: "bg-emerald-600 hover:bg-emerald-700",
    features: [t("Agenti illimitati"), t("Prodotti illimitati"), t("Clienti illimitati"), t("Ordini, PDF e scorte"), t("Statistiche e report provvigioni"), t("Assistente AI con chat integrata")],
  },
];
